module.exports = __webpack_public_path__ + "img/WebPage.bf54fe4a.png";